module.exports = __webpack_public_path__ + "static/media/github.f683ba32.png";